module.exports = __webpack_public_path__ + "static/media/Group11.b42bce83.svg";